import apicaller from "@/utils/apicaller";
import api from "../main.api";
export default {
    getIncidents(params) {
        return apicaller.post(api.KYCV2.incidents, params);
    },
    getIncidentById(id) {
        return apicaller.get(`${api.KYCV2.incident}/${id}`);
    },
    getIncidentDetails(id) {
        return apicaller.get(`${api.KYCV2.incident}/${id}/details`);
    },
    updateStatus(payload) {
        return apicaller.post(api.KYCV2.incidentUpdateStatus, payload);
    },
    decide(payload) {
        return apicaller.post(api.KYCV2.incidentDecide, payload);
    },
    assign(payload) {
        return apicaller.post(api.KYCV2.incidentAssign, payload);
    },
    execute(payload) {
        return apicaller.post(api.PREPAREDQUERY.executePreparedQuery, payload);
    },
    getIncidentHistory(id) {
        return apicaller.get(`${api.KYCV2.incident}/${id}/history`);
    }
}
